import Vue from "vue";
import Router from "vue-router";
import store from "@store";
import multiguard from "vue-router-multiguard";
import moment from "moment";

import HomeView from "@pages/Home.vue";
import PageNotFound from "@pages/errors/PageNotFound.vue";
import LoginView from "@pages/auth/Login.vue";
import TeamEntryView from "@pages/TeamEntry.vue";
import RegisterView from "@pages/auth/Register.vue";
import RegisterTeamEntryView from "@pages/auth/RegisterTeamEntry.vue";
import RegisterNetballView from "@pages/auth/RegisterNetball.vue";
import DrawView from "@pages/draw/Draw.vue";
import ResultView from "@pages/draw/Result.vue";
import StatsView from "@pages/draw/Stats.vue";
import EmailUsernameView from "@pages/auth/password/EmailUsername.vue";
import EmailPasswordView from "@pages/auth/password/EmailPassword.vue";
import ResetPasswordView from "@pages/auth/password/ResetPassword.vue";
import MemberView from "@pages/users/Member.vue";
import DashboardView from "@pages/users/Dashboard.vue";
import ProfileView from "@components/users/Profile.vue";
import TeamNomination from "@components/users/TeamNomination.vue";
import TeamsView from "@components/users/Teams.vue";
import TeamDetail from "@components/users/TeamDetail.vue";
import MembershipView from "@components/users/Membership.vue";
import InvoicesView from "@components/users/Invoices.vue";
import InvoiceDetail from "@components/users/InvoiceDetail.vue";
import InvoicePayment from "@components/users/InvoicePayment.vue";
import OrdersView from "@components/users/Orders.vue";
import OrderDetail from "@components/users/OrderDetail.vue";
import RefereeView from "@components/users/Referee.vue";
import RefereeAvailView from "@components/users/RefereeAvail.vue";
import RosterView from "@components/users/Roster.vue";
import BookingsView from "@components/users/Bookings.vue";
import MyBookingsView from "@components/users/MyBookings.vue";
import ProductsView from "@components/users/Products.vue";
import CheckoutView from "@components/users/Checkout.vue";
import NoticeboardView from "@components/users/NoticeBoard.vue";
import EftView from "@components/users/Eft.vue";
import HpcView from "@pages/users/Hpc.vue";
import HpcDashboardView from "@pages/users/HpcDashboard.vue";
import PlansView from "@components/users/Plans.vue";
import PlanPayment from "@components/users/PlanPayment.vue";
import ClassesView from "@components/users/Classes.vue";
import HpcEnrollView from "@components/users/HpcEnroll.vue";
import HpcSubscriptionView from "@components/users/HpcSubscription.vue";
import HpcOrderView from "@components/users/HpcOrders.vue";
import HpcProductView from "@components/users/HpcProducts.vue";

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
    window.scroll(0, 0);
    if (!store.getters["auth/isAuthenticated"]) {
        next();
        return;
    }

    if (to.name != "draw" && to.name != "result" && to.name != "storeview" && to.name != "bookingview") {
        next({ name: "dashboard" });
    } else {
        if (to.name == "storeview") {
            next({
                name: "products",
                query: { category: to.query.category },
            });
        } else if (to.name == "bookingview") {
            next({
                name: "bookings",
                query: { venue: to.query.venue },
            });
        } else {
            next();
        }
    }
};

const ifAuthenticated = (to, from, next) => {
    window.scroll(0, 0);
    if (store.getters["auth/isAuthenticated"]) {
        next();
        return;
    }

    next({
        name: "home",
        query: { redirect: to.fullPath },
    });
};

const ifNonPlayer = (to, from, next) => {
    window.scroll(0, 0);
    if (store.getters["user/getProfile"].non_pl == false) {
        next();
        return;
    }

    next({ name: "dashboard" });
};

const ifNotAdult = (to, from, next) => {
    window.scroll(0, 0);
    if (moment(store.getters["user/getProfile"].dob, "DD-MM-YYYY").isBefore(moment().subtract(18, "years"))) {
        next();
        return;
    }

    next({ name: "dashboard" });
};

// const ifNonRep = (to, from, next) => {
//     if (store.getters['user/getProfile'].is_rep == true) {
//         next();
//         return
//     }
//     next({ name: 'dashboard' });
// }

const ifNonHpc = (to, from, next) => {
    window.scroll(0, 0);
    if (store.getters["user/getProfile"].is_hpc == true) {
        next();
        return;
    }

    next({ name: "dashboard" });
};

const ifNonRef = (to, from, next) => {
    window.scroll(0, 0);
    if (store.getters["user/getProfile"].is_ref == true) {
        next();
        return;
    }

    next({ name: "dashboard" });
};

const ifNotEFT = (to, from, next) => {
    window.scroll(0, 0);
    if (store.getters["user/getProfile"].is_eft == true) {
        next();
        return;
    }

    next({ name: "dashboard" });
};

const ifNonManager = (to, from, next) => {
    window.scroll(0, 0);
    if (store.getters["user/getProfile"].is_man == true) {
        next();
        return;
    }

    next({ name: "dashboard" });
};

const ifNonRoster = (to, from, next) => {
    window.scroll(0, 0);
    if (store.getters["user/getProfile"].is_roster == true) {
        next();
        return;
    }

    next({ name: "dashboard" });
};

const ifRequiredFields = (to, from, next) => {
    window.scroll(0, 0);
    let user = store.getters["user/getProfile"];
    if (
        user.firstname &&
        user.lastname &&
        user.dob &&
        user.gender &&
        user.address &&
        user.suburb &&
        user.state &&
        user.postcode &&
        user.mobile &&
        user.email &&
        user.ec_fullname &&
        user.ec_mobile &&
        user.agreed_to_terms &&
        user.agreed_to_privacy
    ) {
        next();
        return;
    }

    next({
        name: "dashboard",
        query: { sport: to.query.sport }
    });
    alert("Redirecting to your dashboard... Please go to your profile then fill in all required information to make payments.");
};

const forceLogout = (to, from, next) => {
    window.scroll(0, 0);
    if (store.getters["auth/isAuthenticated"]) {
        store.dispatch("auth/authLogout").then(() => {
            next();
            return;
        });
    }

    next();
};

export default new Router({
    // mode: 'history',
    routes: [
        {
            path: "/",
            name: "home",
            component: HomeView,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: "/login/:xyz?/:zyx?/",
            name: "login",
            component: LoginView,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: "/draw/:season_id?/:division_id?/:team_name?/",
            name: "draw",
            component: DrawView,
            beforeEnter: ifNotAuthenticated,
        },
        // {
        //     path: "/stats/:season_id?/:division_id?/:team_id?/",
        //     name: "stats",
        //     component: StatsView,
        //     beforeEnter: ifAuthenticated,
        // },
        {
            path: "/storeview",
            name: "storeview",
            component: ProductsView,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: "/bookingview",
            name: "bookingview",
            component: BookingsView,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: "/result",
            name: "result",
            component: ResultView,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: "/teamentry",
            name: "teamentry",
            component: TeamEntryView,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/registerteamentry',
            name: 'registerteamentry',
            component: RegisterTeamEntryView,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/registernetball',
            name: 'registernetball',
            component: RegisterNetballView,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: "/register",
            name: "register",
            component: RegisterView,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: "/username/email/",
            name: "username-email",
            component: EmailUsernameView,
            beforeEnter: forceLogout,
        },
        {
            path: "/password/email/",
            name: "password-email",
            component: EmailPasswordView,
            beforeEnter: forceLogout,
        },
        {
            path: "/password/reset/:token",
            name: "password-reset",
            component: ResetPasswordView,
            beforeEnter: forceLogout,
        },
        {
            path: "/member",
            name: "member",
            component: MemberView,
            beforeEnter: ifAuthenticated,
            children: [
                {
                    path: "account",
                    // redirect: { name: 'profile' },
                    name: "dashboard",
                    component: DashboardView,
                    beforeEnter: ifAuthenticated,
                },
                {
                    path: "eftaccount",
                    name: "eft",
                    component: EftView,
                    beforeEnter: multiguard([ifAuthenticated, ifNotEFT]),
                },
                {
                    path: "noticeboard",
                    // redirect: { name: 'profile' },
                    name: "noticeboard",
                    component: NoticeboardView,
                    beforeEnter: multiguard([ifAuthenticated, ifNonManager]),
                },
                {
                    path: "profile",
                    name: "profile",
                    component: ProfileView,
                    beforeEnter: ifAuthenticated,
                },
                {
                    path: "teamnomination",
                    name: "teamNomination",
                    component: TeamNomination,
                    beforeEnter: multiguard([ifAuthenticated, ifNotAdult]),
                },
                {
                    path: "teams",
                    name: "teamsList",
                    component: TeamsView,
                    props: true,
                    beforeEnter: ifAuthenticated,
                },
                {
                    path: "teams/team/:team_id",
                    name: "teamDetail",
                    component: TeamDetail,
                    props: true,
                    beforeEnter: ifAuthenticated,
                },
                {
                    path: "stats/:season_id?/:division_id?/:team_id?/",
                    name: "statsList",
                    component: StatsView,
                    beforeEnter: ifAuthenticated,
                },
                {
                    path: "invoices",
                    name: "invoicesList",
                    component: InvoicesView,
                    props: true,
                    beforeEnter: ifAuthenticated,
                },
                {
                    path: "invoices/invoice/:invoice_id",
                    name: "invoiceDetail",
                    component: InvoiceDetail,
                    props: true,
                    beforeEnter: ifAuthenticated,
                },
                {
                    path: "invoices/invoice/:invoice_id/payment",
                    name: "invoicePayment",
                    component: InvoicePayment,
                    props: true,
                    beforeEnter: multiguard([ifAuthenticated, ifRequiredFields]),
                },
                {
                    path: "membership",
                    name: "membership",
                    component: MembershipView,
                    beforeEnter: multiguard([ifAuthenticated, ifNonPlayer, ifRequiredFields]),
                },
                {
                    path: "orders",
                    name: "ordersList",
                    component: OrdersView,
                    props: true,
                    beforeEnter: ifAuthenticated,
                },
                {
                    path: "orders/order/:order_id/:typeorig?",
                    name: "orderDetail",
                    component: OrderDetail,
                    props: true,
                    beforeEnter: ifAuthenticated,
                },
                {
                    path: "referee",
                    name: "referee",
                    component: RefereeView,
                    beforeEnter: multiguard([ifAuthenticated, ifNonRef]),
                },
                {
                    path: "refereeavail",
                    name: "refereeavail",
                    component: RefereeAvailView,
                    beforeEnter: multiguard([ifAuthenticated, ifNonRef]),
                },
                {
                    path: "roster",
                    name: "roster",
                    component: RosterView,
                    beforeEnter: multiguard([ifAuthenticated, ifNonRoster]),
                },
                {
                    path: "booking",
                    name: "bookings",
                    component: BookingsView,
                    beforeEnter: multiguard([ifAuthenticated]),
                },
                {
                    path: "mybooking",
                    name: "mybookings",
                    component: MyBookingsView,
                    beforeEnter: multiguard([ifAuthenticated]),
                },
                {
                    path: "store/:typeorig?",
                    name: "products",
                    component: ProductsView,
                    beforeEnter: multiguard([ifAuthenticated]),
                },
                {
                    path: "checkout",
                    name: "checkout",
                    component: CheckoutView,
                    beforeEnter: multiguard([ifAuthenticated]),
                },
                {
                    path: "hpc",
                    name: "hpc",
                    component: HpcView,
                    beforeEnter: multiguard([ifAuthenticated, ifNonHpc]),
                    children: [
                        {
                            path: "home",
                            name: "hpcDashboard",
                            component: HpcDashboardView,
                            beforeEnter: multiguard([ifAuthenticated, ifNonHpc]),
                        },
                        {
                            path: "classes",
                            name: "hpcClasses",
                            component: ClassesView,
                            beforeEnter: multiguard([ifAuthenticated, ifNonHpc]),
                        },
                        {
                            path: "plans",
                            name: "hpcPlans",
                            component: PlansView,
                            beforeEnter: multiguard([ifAuthenticated, ifNonHpc]),
                        },
                        {
                            path: "plans/plan/:plan_id/payment",
                            name: "planPayment",
                            component: PlanPayment,
                            props: true,
                            beforeEnter: multiguard([ifAuthenticated, ifNonHpc]),
                        },
                        {
                            path: "orders",
                            name: "hpcOrders",
                            component: HpcOrderView,
                            beforeEnter: multiguard([ifAuthenticated, ifNonHpc]),
                        },
                        {
                            path: "subscription",
                            name: "hpcSubscription",
                            component: HpcSubscriptionView,
                            beforeEnter: multiguard([ifAuthenticated, ifNonHpc]),
                        },
                        {
                            path: "enrolled",
                            name: "hpcEnrolled",
                            component: HpcEnrollView,
                            beforeEnter: multiguard([ifAuthenticated, ifNonHpc]),
                        },
                        {
                            path: "products",
                            name: "hpcProducts",
                            component: HpcProductView,
                            beforeEnter: multiguard([ifAuthenticated, ifNonHpc]),
                        }
                    ]
                },
            ],
        },
        // and finally the default route, when none of the above matches:
        {
            path: "*",
            component: PageNotFound,
        },
    ],
});
